<template>

    <div>

        <template v-if="total === 0">
            <div class="d-flex border-bottom pb-3 mb-5">
                {{ __('Keine Ergebnisse') }}
            </div>
        </template>

        <template v-else>
            <div class="d-flex align-items-center justify-content-between border-bottom pb-3 mb-5">
                
                <div v-if="(from || to) && total">
                    {{ __(':from - :to von :total Ergebnissen', {from: from, to: to, total: $options.filters.localizeNumber(total)}) }}
                </div>
                <div v-else-if="from || to">
                    {{ __('Ergebnisse :from - :to', {from: from, to: to}) }}
                </div>

                <div>
                    <select class="form-select" id="orderBySelect" aria-label="Sortieren nach" v-model="form.order_by">
                        <option :value="k" v-for="(v, k) in orderByOptions">{{ v }}</option>
                    </select>
                </div>
            </div>
        </template>

    </div>

</template>


<script>
    export default {
        props: [
            'total',
            'from',
            'to',
            'filters',
        ],
        data() {
            return {
                orderByOptions: {
                    relevance: this.__('Beste Ergebnisse'),
                    date: this.__('Neue Produkte'),
                    price_asc: this.__('Preis aufsteigend'),
                    price_desc: this.__('Preis absteigend'),
                },
                form: {
                    page: null,
                    order_by: this.filters.order_by || 'relevance',
                },
            }
        },
        methods: {
        },
        watch: {
            form: {
                deep: true,
                handler: _.throttle(function () {
//                    this.$emit('loading', true);
                    this.$inertia.get(window.location, this.form, {
                        preserveScroll: true,
                        preserveState: true,
                    });
//                    this.$emit('loading', false);
                }, 150),
            },
        },
    }
</script>